import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		female: {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=female&exp=web_upsell_double_offering~1
			upsell: {
				routeNames: [
					'upsell-static-subscription-activated',
					'upsell-f',
					'upsell-additional-fasting-b',
					'upsell-upgrade-f',
				],
			},
		},
		'activity-female-pilates': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-pilates&exp=web_upsell_double_offering~1
			upsell: {
				routeNames: ['upsell-pilates-f', 'upsell-additional-activity-b'],
			},
		},
		'activity-female-walking': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-walking&exp=web_upsell_double_offering~1
			upsell: {
				routeNames: ['upsell-walking-f', 'upsell-additional-activity-b'],
			},
		},
	},
	{
		female: {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=female&exp=web_upsell_double_offering~2
			upsell: {
				routeNames: [
					'upsell-static-subscription-activated',
					'upsell-f',
					'upsell-additional-fasting-c',
					'upsell-upgrade-f',
				],
			},
		},
		'activity-female-pilates': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-pilates&exp=web_upsell_double_offering~2
			upsell: {
				routeNames: ['upsell-pilates-f', 'upsell-additional-activity-c'],
			},
		},
		'activity-female-walking': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-walking&exp=web_upsell_double_offering~2
			upsell: {
				routeNames: ['upsell-walking-f', 'upsell-additional-activity-c'],
			},
		},
	},
]

export default config
